import { ContentViews } from "pages/[orgId]/explore/lib/useContentView";
import { serializeContentView } from "pages/[orgId]/explore/lib/useContentView";
import { serializeDocument } from "pages/[orgId]/explore/lib/useExploreDocument";
import { serializeTabs } from "pages/[orgId]/explore/lib/useTabs";
import { serializeParams } from "src/search/lib/params-state-reducer";
import { SearchState } from "src/search/types";
import { Duration } from "src/utils/date";

const jiraTicketRegex = new RegExp(/[A-Za-z]+-\d+/g);

export const generateLink = (
  entityType: string,
  orgId: string,
  field: string,
  value: string
): string => {
  const searchState = {
    select: [entityType],
    orgId,
    filters: [
      {
        attribute: field,
        comparison: {
          IN: [value],
        },
        key: `${entityType}.${field}`,
        target: entityType,
      },
    ],
  };
  return exploreFromSearchState(
    searchState,
    `${entityType} ${field} is ${value}`
  );
};

export const exploreFromSearchState = (
  searchState: SearchState,
  title = "New question from entity",
  view: string | undefined = undefined
): string => {
  const serialized = serializeParams(searchState);
  const serializedView =
    view ||
    serializeContentView({
      value: ContentViews.default,
      config: {},
    });
  const serializedTabs = serializeTabs({});
  const serializedDoc = serializeDocument({ title, saved: false });
  return `/${searchState.orgId}/explore?s=${serialized}&v=${serializedView}&d=${serializedDoc}&t=${serializedTabs}`;
};

export const extractTicketKeys = (message: string): string[] => {
  if (message === undefined) {
    return [];
  }
  const matches = message.match(jiraTicketRegex);
  return matches ? matches : [];
};

type SearchFilter = {
  attribute: string;
  term: string;
};
export const applySearchFilter = (
  searchState: SearchState,
  searchAttrTerm: SearchFilter[]
) => {
  const filters = searchAttrTerm.map((searchAttrTerm) => {
    return {
      attribute: searchAttrTerm.attribute,
      comparison: {
        IN: [searchAttrTerm.term],
      },
      key: `Event.${searchAttrTerm.attribute}`,
      target: "Event",
    };
  });
  searchState.filters = searchState.filters?.concat(filters);
  return searchState;
};

export const filterByEntity = (
  orgId: string,
  entityTypes: string[],
  searchTerm?: string,
  duration?: Duration
): SearchState => ({
  search: searchTerm,
  orgId,
  duration,
  filters: [
    {
      attribute: "EntityType",
      comparison: {
        IN: entityTypes,
      },
      key: `Event.EntityType`,
      target: "Event",
    },
  ],
});
